import React, { Component } from 'react';
import './Paginator.css';

function PageLink(props) {
  var content;
  const target = props.listObj.urlFor({page: props.page})
  if (props.page) {
    content = (<a href={target} className="pure-menu-link" onClick={props.getPage} data-target={target}>{props.children}</a>);
  } else {
    content = props.children;
  }
  return (<div>{content}</div>);
}

export class Paginator extends Component {
  previousChar = '\u21E0';
  nextChar = '\u21E2';
  moreChar = '\u2026';
  radius = 2;
  render() {
    // render these things:
    // <- [1] 2 3 4 ... 22 ->
    // <- 1 [2] 3 4 5 ... 22 ->
    // <- 1 ... 4 5 6 [7] 8 9 10 ... 22 ->
    // <- 1 ... 18 19 20 [21] 22 ->
    // <- 1 ... 19 20 21 [22] ->
    var rangeStart = this.props.page_number - this.radius;
    var rangeEnd = this.props.page_number + this.radius;
    var previousPage;
    var nextPage;
    if (this.props.page_number !== 1) {
      previousPage = this.props.page_number - 1;
    }
    if (this.props.page_number !== this.props.page_count) {
      nextPage = this.props.page_number + 1;
    }

    if (rangeStart < 1) {
      rangeStart = 1;
    }
    if (rangeEnd > this.props.page_count) {
      rangeEnd = this.props.page_count;
    }

    var range = []
    for (var i=rangeStart; i <= rangeEnd; i++) {
      var classList = ['pure-menu-item'];
      switch (this.props.page_number) {
        case i:
          classList.push('pure-menu-selected');
          break;
        case (i+1):
        case (i-1):
          // add a neighbor class for small screens.
          classList.push('pure-menu-neighbor');
          break
        default:
          // do nothing.
      }
      range.push(<li className={classList.join(" ")} key={i}><PageLink {...this.props} page={i}>{i}</PageLink></li>)
    }
    const previousClass = "pure-menu-item Paginator-nav" + (previousPage?"":" pure-menu-disabled");
    const nextClass = "pure-menu-item Paginator-nav" + (nextPage?"":" pure-menu-disabled");
    return (<div className="Paginator pure-menu pure-menu-horizontal">
      <ul className="Paginator-range pure-menu-list">
        <li className={previousClass}><PageLink {...this.props} page={previousPage}>{this.previousChar}</PageLink></li>
        {rangeStart !== 1 && <li className="Paginator-first pure-menu-item"><PageLink {...this.props} page={1}>1</PageLink></li>}
        {rangeStart > 2 && <li className="Paginator-more pure-menu-heading">{this.moreChar}</li>}
        {range}
        {rangeEnd !== this.props.page_count && <li className="Paginator-more pure-menu-item">{this.moreChar}</li>}
        {rangeEnd !== this.props.page_count && <li className="Paginator-last pure-menu-item"><PageLink {...this.props} page={this.props.page_count}>{this.props.page_count}</PageLink></li>}
        <li className={nextClass}><PageLink {...this.props} page={nextPage}>{this.nextChar}</PageLink></li>
      </ul>
    </div>);
  }
}


// WEBPACK FOOTER //
// ./src/Components/Paginator.js